<template>
    <div v-if="eventHasProducts">
        <div class="row align-content-center py-3 fix--ticket--item" @click="toggle">
            <div class="col">
                <h3 class="c-gray fix--ticket--header">{{ day }}</h3>
            </div>
            <div class="col-auto col-md text-center">
                <h3 class="c-gray fix--ticket--header">{{ event.price | currency }}</h3>
            </div>
            <div class="col text-right">
                <icon-base :view-box-height="512"
                           :view-box-width="320"
                           :width="30"
                           icon-color="#166ba6"
                           :height="30"
                           :class="classes">
                    <sort-down-icon></sort-down-icon>
                </icon-base>
            </div>
        </div>
        <vue-slide-up-down :active="show" :duration="1000">
            <fix-ticket-header :start-date="startDate"></fix-ticket-header>
            <product :data="product" :increase="increase" :decrease="decrease" v-for="product in event.ticket.products" :key="product.key"></product>
        </vue-slide-up-down>
    </div>
</template>

<script>
    import moment from 'moment';
    import VueSlideUpDown from 'vue-slide-up-down';
    import cartMixin from '../mixins/cartMixin';
    import * as Actions from '../store/action-types';

    export default {
        mixins: [cartMixin],

        components: {VueSlideUpDown},

        props: {
            data: {
                type: Object,
                required: true
            },

            month: {
                type: String
            },

            date: {
                type: String
            },

            startDate: {
                type: String,
                required: true
            },

        },

        data() {
            return {
                event: this.data,
                show: false
            }
        },

        computed: {
            day() {
                return moment(this.date).format('dd DD');
            },

            classes() {
                return !this.show
                    ? ['fix--ticket--toggle--icon']
                    : ['fix--ticket--toggle--icon', 'active'];
            },

            discountClass() {
                switch (this.event.desc) {
                    default:
                        return ['c-blue'];
                }
            },

            eventHasProducts() {
                return this.event && this.event.ticket;
            }
        },

        methods: {
            toggle() {
                this.show = !this.show;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/FixTicket.vue